function injectStyle (ssrContext) {
  require("!!../../../daoluyanghu/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../daoluyanghu/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-30b969e4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../daoluyanghu/node_modules/vue-loader/lib/selector?type=styles&index=0!./lyGroup.vue")
}
var normalizeComponent = require("!../../../daoluyanghu/node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = null
/* template */
import __vue_template__ from "!!../../../daoluyanghu/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-30b969e4\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../daoluyanghu/node_modules/vue-loader/lib/selector?type=template&index=0!./lyGroup.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ../common/src/components/lyGroup.vue
// module id = null
// module chunks = 